<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <CreateSystem
        :tabs="tabs"
        title="Windows"
      >
        <template v:slot:instructions>
          <div>
            <p>
              Secure your Windows devices by installing the JumpCloud Agent.
              {{ installMethodsText }}
            </p>
          </div>
        </template>
      </CreateSystem>
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { SystemCompatibilityConsts } from 'client/util/Constants';
import { mapState } from 'vuex';
import AgentInstructions from 'client/systems/AgentInstructions.vue';
import CreateSystem from 'client/systems/CreateSystem.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import TerminalInstructions from 'client/systems/TerminalInstructions.vue';

export default {
  name: 'CreateWindowsSystem',

  components: {
    CreateSystem,
    DetailsAsideLayout,
  },

  mixins: [
    CreateSystemMixin,
  ],

  data() {
    return {
      copyWell: {
        content: this.connectKey,
        label: 'Connect Key',
        showTooltip: true,
        tooltipLabel: 'The Connect Key provides you with a means of associating your systems with your JumpCloud organization. Each JumpCloud Administrator has a unique Connect Key; although this is not considered a secret and any Key can be used to deploy the agent to a system.',
        rows: 1,
      },
      kbLinkTerminal: {
        href: KbArticleUrls.installWindowsAgent,
        text: 'Installing the Windows Agent from the Terminal',
      },
      remoteAgentHref: KbArticleUrls.remoteAgentInstall,
    };
  },

  computed: {
    ...mapState('SettingsModule', [
      'windowsAgentUrl',
      'windowsAgentMsiUrl',
    ]),

    compatibilityNotes() {
      return {
        header: 'Supported versions',
        text: SystemCompatibilityConsts.windows,
        kbLink: this.kbLink,
      };
    },

    installMethodsText() {
      return 'There are three methods:';
    },

    tabs() {
      const downloadExeTab = {
        component: AgentInstructions,
        componentProps: {
          agentUrl: this.windowsAgentUrl,
          compatibilityNotes: this.compatibilityNotes,
          connectKey: this.connectKey,
          copyWell: this.copyWell,
          copyWellLocation: 'Windows Copy Download Link',
          downloadButtonText: 'Download Windows Agent',
          instructionsText: 'To install the JumpCloud agent on your Windows system download the installer below or send the download link to your user. You must be an administrator on the system to run the installer. Either an administrator needs to log on to the Windows system or you need to give your user administrator permissions on the system. When running the installer you are prompted to paste in the Connect Key below to complete installation.',
          kickstart: this.kickstart,
          system: 'windows',
        },
        title: 'Install via EXE Download',
      };
      const downloadMsiTab = {
        component: AgentInstructions,
        componentProps: {
          agentUrl: this.windowsAgentMsiUrl,
          compatibilityNotes: this.compatibilityNotes,
          connectKey: this.connectKey,
          copyWell: this.copyWell,
          copyWellLocation: 'Windows MSI Copy Download Link',
          downloadButtonText: 'Download MSI Installer',
          instructionsText: 'To install JumpCloud on your Windows device via MSI Download, use one of the 3 options below:',
          instructionLinkSteps: [
            {
              startText: 'Deploy using the command line/PowerShell.', linkText: '', endText: '', kbLink: '',
            },
            {
              startText: 'Deploy using GPO/Intune.', linkText: '', endText: '', kbLink: '',
            },
            {
              startText: 'Manually install to a single device by downloading the MSI file and running it.', linkText: '', endText: '', kbLink: '',
            },
          ],
          instructionStepsSummary: {
            startText: 'For more information, see ', linkText: 'JumpCloud Agent Windows Installation Walkthrough', endText: '.', kbLink: KbArticleUrls.InstallWindowsAgentSteps,
          },
          kickstart: this.kickstart,
          system: 'windows',
        },
        title: 'Install via MSI Download',
      };
      const powershellStepsTab = {
        component: TerminalInstructions,
        componentProps: {
          copyWellTerminal: this.copyWellPowershell,
          kbLinkTerminal: this.kbLinkTerminal,
          instructions: {
            text: 'To install JumpCloud on your Windows system via PowerShell:',
            steps: [
              'Open a PowerShell prompt with Run As Administrator',
              'Copy and Paste the command below into PowerShell',
              'It may take one or two minutes to see the system in your Admin Console',
            ],
          },
          system: 'windows',
        },
        title: 'Install via PowerShell',
      };

      return [downloadExeTab, downloadMsiTab, powershellStepsTab];
    },
  },
};
</script>
<style module>
@import './CreateSystem.css';
</style>
